import axios from 'axios';
import api from '@src/api';
import cloneDeep from 'lodash/cloneDeep';

export const state = {
  allExerciseDifficulties: [],
  exerciseDifficultyDetails: {},
};

export const getters = {
  exerciseDifficultyLabelMap: (state) => {
    const map = {};
    if (state.allExerciseDifficulties) {
      state.allExerciseDifficulties.forEach((exerciseDifficulty) => {
        map[exerciseDifficulty.label] = exerciseDifficulty;
      });
    }
    return map;
  },
  exerciseDifficultyIdMap: (state) => {
    const map = {};
    if (state.allExerciseDifficulties) {
      state.allExerciseDifficulties.forEach((exerciseDifficulty) => {
        map[exerciseDifficulty._id] = exerciseDifficulty;
      });
    }
    return map;
  },
};

export const mutations = {
  setAllExerciseDifficulties(state, value) {
    const sortedDifficulties = value.sort(function(a, b) {
      return a.order - b.order;
    });
    state.allExerciseDifficulties = sortedDifficulties;
  },
  setExerciseDifficultyDetails(state, value) {
    const clone = cloneDeep(state.exerciseDifficultyDetails);
    clone[value._id] = value;
    state.exerciseDifficultyDetails = clone;
  },
  setDeleteExerciseDifficultyItem(state, value) {
    const i = state.allExerciseDifficulties.findIndex(
      (item) => item._id === value._id
    );
    state.allExerciseDifficulties.splice(i, 1);
  },
};

export const actions = {
  getAllExerciseDifficulties(ctx, { orgId, trainerId }) {
    if (orgId !== undefined && trainerId !== undefined) {
      const url = api.URL_GET_ALL_EXERCISE_DIFFICULTY.replace(
        ':orgID',
        orgId
      ).replace(':trainerID', trainerId);

      return axios
        .get(url)
        .then((res) => {
          ctx.commit(
            'setAllExerciseDifficulties',
            res.data.exerciseDifficulties
          );
          return res.data;
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(
        `invalid params (orgId, trainerId) : (${orgId}, ${trainerId})`
      );
    }
  },

  getExerciseDifficulty(ctx, { exerciseDifficultyId, orgId, trainerId }) {
    if (
      exerciseDifficultyId !== undefined &&
      orgId !== undefined &&
      trainerId !== undefined
    ) {
      if (!ctx.state.exerciseDifficultyDetails[exerciseDifficultyId]) {
        const url = api.URL_GET_EXERCISE_DIFFICULTY.replace(
          ':exerciseDifficultyID',
          exerciseDifficultyId
        )
          .replace(':orgID', orgId)
          .replace(':trainerID', trainerId);

        return axios
          .get(url)
          .then((res) => {
            ctx.commit('setExerciseDifficultyDetails', res.data);
            return res.data;
          })
          .catch((err) => {
            console.warn(err);
          });
      } else {
        return ctx.state.exerciseDifficultyDetails[exerciseDifficultyId];
      }
    } else {
      console.error(
        `invalid params (exerciseDifficultyId, orgId, trainerId) : (${exerciseDifficultyId}, ${orgId}, ${trainerId})`
      );
    }
  },

  createExerciseDifficulty(ctx, { exerciseDifficultyObj, trainerId }) {
    if (exerciseDifficultyObj !== undefined && trainerId !== undefined) {
      const url = api.URL_CREATE_EXERCISE_DIFFICULTY.replace(
        ':trainerID',
        trainerId
      );

      // Minimum data check for creating a new piece of exerciseDifficulty
      if (
        exerciseDifficultyObj.trainer_id !== undefined &&
        exerciseDifficultyObj.org_id !== undefined &&
        exerciseDifficultyObj.label !== undefined &&
        exerciseDifficultyObj.strength !== undefined
      ) {
        const requestPayload = { exerciseDifficulty: exerciseDifficultyObj };
        return axios
          .put(url, requestPayload)
          .then((res) => {
            return res.data;
          })
          .catch((err) => {
            console.warn(err);
          });
      } else {
        console.error(
          'exerciseDifficultyObj must contain the following properties [trainer_id, org_id, label, strength]',
          exerciseDifficultyObj
        );
      }
    } else {
      console.error(
        `invalid params (exerciseDifficultyObj, trainerId) : (${exerciseDifficultyObj}, ${trainerId})`
      );
    }
  },

  updateExerciseDifficulty(
    ctx,
    { trainerId, exerciseDifficultyId, exerciseDifficultyObj, isReplacement }
  ) {
    if (
      exerciseDifficultyId !== undefined &&
      exerciseDifficultyObj !== undefined
    ) {
      const url = api.URL_UPDATE_EXERCISE_DIFFICULTY.replace(
        ':trainerID',
        trainerId
      ).replace(':exerciseDifficultyID', exerciseDifficultyId);

      // minimum data check for creating a new piece of exerciseDifficulty
      if (
        !isReplacement ||
        (exerciseDifficultyObj.trainer_id !== undefined &&
          exerciseDifficultyObj.org_id !== undefined &&
          exerciseDifficultyObj.label !== undefined &&
          exerciseDifficultyObj.strength !== undefined)
      ) {
        const requestPayload = { exerciseDifficulty: exerciseDifficultyObj };
        return axios
          .post(url, requestPayload)
          .then((res) => {
            return res.data;
          })
          .catch((err) => {
            console.warn(err);
          });
      } else {
        console.error(
          'exerciseDifficultyObj must contain the following properties to be a valid replacement [trainer_id, org_id, label, strength]',
          exerciseDifficultyObj
        );
      }
    } else {
      console.error(
        `invalid params (exerciseDifficultyId, exerciseDifficultyObj) : (${exerciseDifficultyId}, ${exerciseDifficultyObj})`
      );
    }
  },

  deleteExerciseDifficulty(ctx, { exerciseDifficultyId, trainerId, orgId }) {
    if (
      exerciseDifficultyId !== undefined &&
      trainerId !== undefined &&
      orgId !== undefined
    ) {
      const url = api.URL_DELETE_EXERCISE_DIFFICULTY.replace(
        ':exerciseDifficultyID',
        exerciseDifficultyId
      )
        .replace(':trainerID', trainerId)
        .replace(':orgID', orgId);

      return axios
        .delete(url)
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(
        `invalid params (exerciseDifficultyId, trainerId, orgId) : (${exerciseDifficultyId}, ${trainerId}, ${orgId})`
      );
    }
  },
};
